import React from "react";
import PedidosYaStyle from "../../../../../assets/css/components/admin/plugins/PedidosYaStyle";
import { BiHide, BiShow, BiX } from "react-icons/bi";
import { GlobalContext } from "../../../../../contexts/GlobalContext";
import { useState, useContext } from "react";
import {
    getCredencials,
    sendCredencials,
    getPagePricelist,
    updatePagePricelist,
} from "../functions/credentialsMethods";
import axios from "axios";
import { keyAccessToken, keyUserId } from "../../../../../assets/js/SessionStorageNames";
import validateDataBeforeSend from "../functions/validateDataBeforeSend";
import { useEffect } from "react";
import { currentPageCredential } from "../../../../../assets/js/SessionStorageNames";

export default function CredentialsWoo(props) {
    /*
     * states
     */
    const [showBadge, setShowBadge] = useState(false);
    const [colorError, setColorError] = useState(true);
    const [error, setError] = useState("");
    const [showPass, setShowPass] = useState(false);
    const [wpUser, setWpUser] = useState("");
    const [wpPass, setWpPass] = useState("");
    const [isLoad, setIsLoad] = useState(false);
    const [url, setUrl] = useState(null);
    const [consumerKey, setConsumerKey] = useState(null);
    const [consumerSecret, setConsumerSecret] = useState(null);
    const [version, setVersion] = useState(null);
    const [website, setWebsite] = useState('');
    const [source, setSource] = useState('');
    const [pricelists, setPricelists] = useState([]);
    const [currentPricelist, setCurrentPricelist] = useState(null);
    const [loadingPricelist, setLoadingPricelist] = useState(false);
    const [defaultPricelistName, setDefaultPricelistName] = useState(null);
    const globalContext = useContext(GlobalContext);
    /*
     * states  end
     */

    /**
     * Cargar las tarifas disponibles
     */
    const loadPricelists = async () => {
        const enterpriseId = globalContext.currentEnterpriseId;
        if (!enterpriseId) return;

        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/v1/odoo-pricelist/${enterpriseId}`,
                {
                    headers: {
                        "x-api-key": process.env.REACT_APP_API_KEY,
                        "x-access-token": localStorage.getItem(keyAccessToken),
                        "x-user-id": localStorage.getItem(keyUserId),
                    },
                }
            );
            if (response.data?.data?.priceLists) {
                setPricelists(response.data.data.priceLists);
            }
        } catch (err) {
            console.error("Error al cargar tarifas:", err);
        }
    };

    /**
     * Cargar la tarifa de la página actual
     */
    const loadPagePricelist = async () => {
        const enterpriseId = globalContext.currentEnterpriseId;
        const idPage = props.currentCred?.idPage;
        if (!enterpriseId || !idPage || !props.showNewConfig) return;

        setLoadingPricelist(true);
        try {
            const response = await getPagePricelist(enterpriseId, idPage);
            if (response.data?.data) {
                setCurrentPricelist(response.data.data.pricelistName);
                setDefaultPricelistName(response.data.data.defaultPricelistName);
            }
        } catch (err) {
            console.error("Error al cargar tarifa de la página:", err);
        } finally {
            setLoadingPricelist(false);
        }
    };

    /**
     * Actualizar la tarifa de la página
     */
    const updatePricelist = async (newPricelistName) => {
        const enterpriseId = globalContext.currentEnterpriseId;
        const idPage = props.currentCred?.idPage;
        
        if (!enterpriseId) {
            setError("Error: No se encontró el ID de la empresa");
            setColorError(true);
            setShowBadge(true);
            setTimeout(() => setShowBadge(false), 5000);
            return;
        }
        
        if (!idPage) {
            setError("Error: No se encontró el ID de la página");
            setColorError(true);
            setShowBadge(true);
            setTimeout(() => setShowBadge(false), 5000);
            return;
        }

        try {
            await updatePagePricelist(enterpriseId, idPage, newPricelistName || null);
            setCurrentPricelist(newPricelistName);
            setError("Tarifa actualizada correctamente.");
            setColorError(false);
            setShowBadge(true);
            setTimeout(() => {
                setShowBadge(false);
            }, 5000);
        } catch (err) {
            // Detectar si el error es por cron en ejecución (código HTTP 409 Conflict)
            const statusCode = err.response?.status;
            const errorMessage = err.response?.data?.message || err.message || '';
            
            if (statusCode === 409) {
                // Error específico: cron en ejecución (Conflict)
                setError(errorMessage || 'No se puede cambiar la tarifa mientras un proceso de actualización está en ejecución. Por favor, espere a que termine.');
                setColorError(true);
                setShowBadge(true);
                setTimeout(() => {
                    setShowBadge(false);
                }, 8000); // Mostrar por más tiempo para que el usuario lea el mensaje
            } else {
                // Error interno no contemplado
                setError(`Error interno al actualizar la tarifa. Por favor, intente nuevamente. Si el problema persiste, contacte al soporte.`);
                setColorError(true);
                setShowBadge(true);
                setTimeout(() => {
                    setShowBadge(false);
                }, 5000);
            }
        }
    };

    useEffect(() => {
        console.log("props.currentCred: ",props.currentCred)
        setUrl(props.currentCred?.url);
        setVersion(props.currentCred?.version);
        setWpUser(props.currentCred?.wpUser);
        setWebsite(props.currentCred?.idOrigin);
        setSource(props.currentCred?.idSource);
        if (props.showNewConfig && props.currentCred?.idPage) {
            loadPagePricelist();
        }
    }, [props.currentCred, props.showNewConfig]);

    useEffect(() => {
        if (props.showNewConfig) {
            loadPricelists();
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [globalContext.currentEnterpriseId, props.showNewConfig]);

    /**
     * setear datos basicos en caso de no tener activa la configuracion nueva
     */
    useEffect(() => {
        const ent = globalContext.currentEnterpriseId;
        if (props.showNewConfig) return;
        if(!ent) return;
        getCredencials(ent)
            .then((response) => {
                const data = response.data.data;
                console.log(data);
                setUrl(data.url);
                setVersion(data.version);
                setWpUser(data.wpUser || "");
                setWpPass(data.wpPass || "");
                setWebsite(data.idOrigin || "");
                setSource(data.idSource || "");
            })
            .catch((error) => {
                console.error("error al obtener las credenciales", error);
            });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [globalContext.currentEnterpriseId]);

    const closeBadge = (e) => {
        e.preventDefault();
        setShowBadge(false);
    };

    const toggleShowPassword = (e) => {
        e.preventDefault();
        setShowPass(!showPass);
    };

    const sendCred = async () => {
        const enterpriseId = globalContext.currentEnterpriseId;
        const credId = localStorage.getItem(currentPageCredential);
        if (!enterpriseId) return;

        const valUrl = props.isValidHttpUrl(url);
        if (!valUrl) {
            setError("Debe ingresar un formato válido para una URL.");
            setShowBadge(true);
            return;
        }
        const dataToSend = {
            url,
            ...(consumerKey && {consumerKey}),
            ...(consumerSecret && {consumerSecret}),
            version,
            enterpriseId,
            wpUser: wpUser || undefined,
            wpPass: wpPass || undefined,
            ...(props.showNewConfig && { credId: credId }),
            ...(source && {source}),
            ...(website && {website}),
        };

        const validationArray = [
            url,
            version,
            enterpriseId,
        ];
        props.showNewConfig && validationArray.push(credId);
        const hasAnyError = validateDataBeforeSend(validationArray);

        if (hasAnyError) {
            await sendCredencials(dataToSend)
                .then((response) => {
                    setColorError(false);
                    setError("Credenciales actualizadas correctamente.");
                    setShowBadge(true);
                    setIsLoad(false);
                    setConsumerKey("");
                    setConsumerSecret("");
                    setTimeout(() => {
                        setShowBadge(false);
                    }, 15000);
                })
                .catch((error) => {
                    setColorError(true);
                    setError(
                        `Error al enviar las credenciales, ${error.message}`
                    );
                    setShowBadge(true);
                    setIsLoad(false);
                    setTimeout(() => {
                        setShowBadge(false);
                    }, 15000);
                });
        } else {
            setError(
                "Verifique que todos los datos son correctos o si le falta algun valor!"
            );
            setShowBadge(true);
            setIsLoad(false);
            setTimeout(() => {
                setShowBadge(false);
            }, 15000);
        }
    };

    return (
        <>
            <PedidosYaStyle.ContBadgeError
                active={showBadge}
                error={colorError}
            >
                <PedidosYaStyle.Text size='.875rem' cl='#FFFFFF'>
                    {error}
                </PedidosYaStyle.Text>
                <PedidosYaStyle.BtnToggleBadge onClick={(e) => closeBadge(e)}>
                    <BiX />
                </PedidosYaStyle.BtnToggleBadge>
            </PedidosYaStyle.ContBadgeError>
            <PedidosYaStyle.ContForm>
                <PedidosYaStyle.HeaderForm>
                    <PedidosYaStyle.Text size='14pt' fw='500' cl='#898989'>
                        Ingrese los datos para{" "}
                        {props.showNewConfig
                            ? "modificar"
                            : "modificar/registrar"}{" "}
                        las credenciales de su tienda en woocommerce{" "}
                        {props.showNewConfig && "seleccionada"}
                    </PedidosYaStyle.Text>
                </PedidosYaStyle.HeaderForm>
                <PedidosYaStyle.BodyForm>
                    <PedidosYaStyle.BodyFormGrid>
                        <PedidosYaStyle.ContInputAndLabel>
                            <PedidosYaStyle.Text size='12pt'>
                                Clave del cliente
                            </PedidosYaStyle.Text>
                            <PedidosYaStyle.ContIconNadInputPass>
                                <PedidosYaStyle.Input
                                    value={consumerKey}
                                    type={showPass ? "text" : "password"}
                                    placeholder='Escriba aqui su clave del cliente'
                                    onChange={(e) =>
                                        setConsumerKey(e.target.value)
                                    }
                                />
                                <PedidosYaStyle.BtnShowPass
                                    onClick={(e) => toggleShowPassword(e)}
                                >
                                    {showPass ? <BiHide /> : <BiShow />}
                                </PedidosYaStyle.BtnShowPass>
                            </PedidosYaStyle.ContIconNadInputPass>
                        </PedidosYaStyle.ContInputAndLabel>

                        <PedidosYaStyle.ContInputAndLabel>
                            <PedidosYaStyle.Text size='12pt'>
                                Clave secreta de cliente
                            </PedidosYaStyle.Text>
                            <PedidosYaStyle.ContIconNadInputPass>
                                <PedidosYaStyle.Input
                                    value={consumerSecret}
                                    type={showPass ? "text" : "password"}
                                    placeholder='Escriba aqui su clave secreta de cliente'
                                    onChange={(e) =>
                                        setConsumerSecret(e.target.value)
                                    }
                                />
                                <PedidosYaStyle.BtnShowPass
                                    onClick={(e) => toggleShowPassword(e)}
                                >
                                    {showPass ? <BiHide /> : <BiShow />}
                                </PedidosYaStyle.BtnShowPass>
                            </PedidosYaStyle.ContIconNadInputPass>
                        </PedidosYaStyle.ContInputAndLabel>

                        <PedidosYaStyle.ContInputAndLabel>
                            <PedidosYaStyle.Text size='12pt'>
                                Url de la pagina
                            </PedidosYaStyle.Text>
                            <PedidosYaStyle.Input
                                value={url || ""}
                                placeholder='Escriba aqui el host de acceso'
                                onChange={(e) => setUrl(e.target.value)}
                            />
                        </PedidosYaStyle.ContInputAndLabel>

                        <PedidosYaStyle.ContInputAndLabel>
                            <PedidosYaStyle.Text size='12pt'>
                                Vesion del API
                            </PedidosYaStyle.Text>
                            <PedidosYaStyle.Input
                                value={version || ""}
                                placeholder='Escriba aqui la versión de acceso (wc/v3)'
                                onChange={(e) => setVersion(e.target.value)}
                            />
                        </PedidosYaStyle.ContInputAndLabel>

                        <PedidosYaStyle.ContInputAndLabel>
                            <PedidosYaStyle.Text size='12pt'>
                                Usuario wordpress
                            </PedidosYaStyle.Text>
                            <PedidosYaStyle.Input
                                placeholder='Escriba aqui el usuario de wordpress'
                                onChange={(e) => setWpUser(e.target.value)}
                            />
                        </PedidosYaStyle.ContInputAndLabel>

                        <PedidosYaStyle.ContInputAndLabel>
                            <PedidosYaStyle.Text size='12pt'>
                                Clave aplicaciones Wordpress
                            </PedidosYaStyle.Text>
                            <PedidosYaStyle.Input
                                placeholder='Escriba aqui la clave para aplicaciones'
                                onChange={(e) => setWpPass(e.target.value)}
                            />
                        </PedidosYaStyle.ContInputAndLabel>

                        <PedidosYaStyle.ContInputAndLabel>
                            <PedidosYaStyle.Text size='12pt'>
                                ID de Página Web en Odoo (website)
                            </PedidosYaStyle.Text>
                            <PedidosYaStyle.Input
                                placeholder='Escriba aqui el ID de Página Web en Odoo (website)'
                                value={website||''}
                                type='number'
                                onChange={(e) => setWebsite(e.target.value)}
                            />
                        </PedidosYaStyle.ContInputAndLabel>

                        <PedidosYaStyle.ContInputAndLabel>
                            <PedidosYaStyle.Text size='12pt'>
                                ID de Fuente en Odoo (source)
                            </PedidosYaStyle.Text>
                            <PedidosYaStyle.Input
                                placeholder='Escriba aqui el ID de Fuente en Odoo (source)'
                                value={source||''}
                                type='number'
                                onChange={(e) => setSource(e.target.value)}
                            />
                        </PedidosYaStyle.ContInputAndLabel>

                        {props.showNewConfig && props.currentCred?.idPage && (
                            <PedidosYaStyle.ContInputAndLabel>
                                <PedidosYaStyle.Text size='12pt'>
                                    Tarifa para esta página web
                                </PedidosYaStyle.Text>
                                {loadingPricelist ? (
                                    <PedidosYaStyle.Text size='12pt' cl='#898989'>
                                        Cargando...
                                    </PedidosYaStyle.Text>
                                ) : (
                                    <>
                                        <PedidosYaStyle.Input
                                            as="select"
                                            value={currentPricelist || ''}
                                            onChange={(e) => updatePricelist(e.target.value || null)}
                                            style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                                        >
                                            <option value="">
                                                {defaultPricelistName ? `Usar tarifa por defecto (${defaultPricelistName})` : 'Usar tarifa por defecto'}
                                            </option>
                                            {pricelists.map((pl, idx) => (
                                                <option key={idx} value={pl.name}>
                                                    {pl.name} {pl.isDefault ? '(Por defecto)' : ''}
                                                </option>
                                            ))}
                                        </PedidosYaStyle.Input>
                                        {currentPricelist && (
                                            <PedidosYaStyle.Text size='10pt' cl='#28a745' style={{ marginTop: '5px' }}>
                                                Tarifa personalizada: {currentPricelist}
                                            </PedidosYaStyle.Text>
                                        )}
                                        {!currentPricelist && defaultPricelistName && (
                                            <PedidosYaStyle.Text size='10pt' cl='#6c757d' style={{ marginTop: '5px' }}>
                                                Usando tarifa por defecto: {defaultPricelistName}
                                            </PedidosYaStyle.Text>
                                        )}
                                    </>
                                )}
                            </PedidosYaStyle.ContInputAndLabel>
                        )}

                    </PedidosYaStyle.BodyFormGrid>
                </PedidosYaStyle.BodyForm>
                <PedidosYaStyle.FooterForm>
                    <PedidosYaStyle.BtnSend
                        disabled={isLoad}
                        onClick={sendCred}
                    >
                        {isLoad ? "Enviando" : "Actualizar Credenciales"}
                    </PedidosYaStyle.BtnSend>
                </PedidosYaStyle.FooterForm>
            </PedidosYaStyle.ContForm>
        </>
    );
}
